import { takeLatest } from 'redux-saga';
import { isBookTripSubmitError } from 'app/sagas/patterns';
import { reportFieldsRequired } from 'app/sagas/logging/google';


export default function* watchSubmitErrors() {
  yield takeLatest(isBookTripSubmitError, reportFieldsRequired);
}
